export default "__VITE_ASSET__CPWwmcRm__"